import { pythonApiClient } from "./python-http-client.service";
import { ChatOrder, EcommSettings, NativeShoppingFlowSettings, OrderPage, OrderStatus, PaymentStatus, StoreContactSettings, WhatsAppCatalogSettings } from "../models/order-crm.model";

const path = (businessId: string) => `/api/ecomm/businesses/${encodeURIComponent(businessId)}`;
export const orderCrmApi = {
  whatsappCatalog: async (businessId: string) =>
    (await pythonApiClient.get<WhatsAppCatalogSettings>(`${path(businessId)}/whatsapp-catalog`)).data,
  saveWhatsappCatalog: async (businessId: string, settings: WhatsAppCatalogSettings) =>
    (await pythonApiClient.put<WhatsAppCatalogSettings>(`${path(businessId)}/whatsapp-catalog`, settings)).data,
  catalogFeed: async (businessId: string) =>
    (await pythonApiClient.get<Blob>(`${path(businessId)}/whatsapp-catalog/feed`, { responseType: "blob" })).data,
  storeContact: async (businessId: string) =>
    (await pythonApiClient.get<StoreContactSettings>(`${path(businessId)}/store-contact`)).data,
  saveStoreContact: async (businessId: string, settings: StoreContactSettings) =>
    (await pythonApiClient.put<StoreContactSettings>(`${path(businessId)}/store-contact`, settings)).data,
  shoppingFlow: async (businessId: string) =>
    (await pythonApiClient.get<NativeShoppingFlowSettings>(`${path(businessId)}/shopping-flow`)).data,
  saveShoppingFlow: async (businessId: string, settings: Pick<NativeShoppingFlowSettings, "enabled" | "flowId">) =>
    (await pythonApiClient.put<NativeShoppingFlowSettings>(`${path(businessId)}/shopping-flow`, settings)).data,
  list: async (businessId: string, params: { start?: string; end?: string; status?: string; paymentStatus?: string; page: number }) =>
    (await pythonApiClient.get<OrderPage>(`${path(businessId)}/orders`, { params })).data,
  update: async (businessId: string, orderId: string, changes: {
    revision: number; status: OrderStatus; paymentStatus: PaymentStatus; deliveryCharge?: string;
    assignedTo: string; crmNotes: string; paymentReference: string;
  }) => (await pythonApiClient.patch<ChatOrder>(`${path(businessId)}/orders/${encodeURIComponent(orderId)}`, changes)).data,
  settings: async (businessId: string) => (await pythonApiClient.get<EcommSettings>(`${path(businessId)}/settings`)).data,
  saveSettings: async (businessId: string, { catalog, paymentQrImage, ...settings }: EcommSettings) =>
    (await pythonApiClient.put<EcommSettings>(`${path(businessId)}/settings`, settings)).data,
  uploadPaymentQr: async (businessId: string, file: File) => {
    const data = new FormData(); data.append("file", file);
    return (await pythonApiClient.post<{ paymentQrImage: NonNullable<EcommSettings["paymentQrImage"]> }>(`${path(businessId)}/payment-qr`, data,
      { headers: { "Content-Type": "multipart/form-data" } })).data;
  },
  removePaymentQr: async (businessId: string) =>
    (await pythonApiClient.delete<{ paymentQrImage: null }>(`${path(businessId)}/payment-qr`)).data,
  upload: async (businessId: string, file: File) => {
    const data = new FormData();
    data.append("file", file);
    return (await pythonApiClient.post<NonNullable<EcommSettings["catalog"]>>(`${path(businessId)}/catalog`, data,
      { headers: { "Content-Type": "multipart/form-data" } })).data;
  },
};
